import {
  Avatar,
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  Image,
  Stack,
  Text
} from "@chakra-ui/react";
import IconArrowLeftRight from "assets/icons/icon-arrow-left-right.svg?react";
import IconBuilding from "assets/icons/icon-building.svg?react";
import IconFileChartLine from "assets/icons/icon-file-chart-line.svg?react";
import IconLayoutGrid from "assets/icons/icon-layout-grid.svg?react";
import IconList from "assets/icons/icon-list.svg?react";
import IconMailStar from "assets/icons/icon-mail-star.svg?react";
import IconNote from "assets/icons/icon-note.svg?react";
import IconParameter from "assets/icons/icon-parameter.svg?react";
import IconSignOut from 'assets/icons/icon-sign-out.svg?react';
import IconUserCheck from "assets/icons/icon-user-check.svg?react";
import logo from "assets/images/logo-patri.svg";
import { usePermissionsContext } from "contexts/PermissionsContext";
import { AuthRepository } from 'features/auth/repositories/AuthRepository';
import { useNewsletterReviewCount } from "features/newsletters/hooks/useNewsletterReviewCount";
import ButtonNewEmail from "./ButtonNewEmail/ButtonNewEmail";
import Navigator from "./ui/Navigator";
import NavigatorGroup from "./ui/NavigatorGroup";
import NavigatorItem from "./ui/NavigatorItem";
import NavigatorScrollArea from "./ui/NavigatorScrollArea";

export default function AppNavigator() {
  const { ability, user } = usePermissionsContext();
  const { data: reviewCount = 0 } = useNewsletterReviewCount();

  const onLogout = async () => {
    const repository = new AuthRepository();
    await repository.logout();
  };

  return (
    <Navigator>
      <Flex justifyContent="center">
        <Image src={logo} alt="Patri" w="120px" />
      </Flex>

      <Divider mt="19px" mb="20px" />

      <NavigatorScrollArea>
        <ButtonNewEmail />

        <Box mb="30px">
          <NavigatorGroup title="Gestão de conteúdo">
            {ability.can("access", "Analytics") && (
              <NavigatorItem icon={<IconLayoutGrid />} to="/analytics">
                Analytics
              </NavigatorItem>
            )}

            <NavigatorItem icon={<IconNote />} to="/notas-de-agenda">
              Notas de Agenda
            </NavigatorItem>
            <NavigatorItem
              icon={<IconArrowLeftRight />}
              to="/disparos-de-agenda"
            >
              Disparos de Agenda
            </NavigatorItem>
            <NavigatorItem
              icon={<IconArrowLeftRight />}
              to="/disparos-de-report"
            >
              Disparos de Report
              {/* <Badge ml="8px">5</Badge> */}
            </NavigatorItem>

            <NavigatorItem
              icon={<IconArrowLeftRight />}
              to="/disparos-de-newsletter"
            >
              Disparos de Newsletter
              {ability.can("review", "Newsletter") && reviewCount > 0 && (
                <Badge
                  pos="absolute"
                  right="0"
                  top="0"
                  variant="solid"
                  colorScheme="red"
                  ml="2px"
                  mt="-8px"
                >
                  {reviewCount}
                </Badge>
              )}
            </NavigatorItem>
            {ability.can("access", "Report") && (
              <NavigatorItem icon={<IconFileChartLine />} to="/relatorios">
                Relatórios
              </NavigatorItem>
            )}
          </NavigatorGroup>

          {user?.role !== "analyst" && (
            <NavigatorGroup title="Configurações">
              {ability.can("manage", "ContentGroup") && (
                <NavigatorItem icon={<IconMailStar />} to="/modelos-de-disparo">
                  Modelos de Disparo
                </NavigatorItem>
              )}
              {ability.can("access", "Company") && (
                <NavigatorItem icon={<IconBuilding />} to="/clientes">
                  Clientes
                </NavigatorItem>
              )}
              {ability.can("manage", "List") && (
                <NavigatorItem icon={<IconList />} to="/listas-de-disparo">
                  Listas de Disparo
                </NavigatorItem>
              )}

              {ability.can("manage", "ContentParameter") && (
                <NavigatorItem icon={<IconParameter />} to="/temas">
                  Parâmetros
                </NavigatorItem>
              )}
              {/* <NavigatorItem icon={<IconImageAdd />} to="/biblioteca-de-midia">Biblioteca de Mídia</NavigatorItem> */}
              {ability.can("manage", "User") && (
                <NavigatorItem icon={<IconUserCheck />} to="/usuarios">
                  Usuários
                </NavigatorItem>
              )}
            </NavigatorGroup>
          )}
        </Box>

        {user && (
          <Stack borderRadius="10px" bgColor="#F6F8FA" gap="0" mt="auto">
            <HStack p="12px">
              <Avatar name={user.name} bg="green.100" color="green.800" />

              <Stack gap="0" overflow="hidden">
                <Text as="span" color="#0A0D14" fontWeight="medium">
                  {user.name}
                </Text>

                <Text
                  as="span"
                  fontSize="12px"
                  noOfLines={1}
                  whiteSpace="nowrap"
                >
                  {user.email}
                </Text>
              </Stack>
            </HStack>

            <Button
              variant="ghost"
              leftIcon={<IconSignOut />}
              onClick={() => onLogout()}
              justifyContent="flex-start"
            >
              Sair
            </Button>
          </Stack>
        )}
      </NavigatorScrollArea>
    </Navigator>
  );
}
